import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import returnOrderConfirm from '@pages/Order/Exchange/components/returnOrderConfirm/index.vue';
export default {
    mixins: [services],
    components: {
        returnOrderConfirm
    },
    props: {
        value: {
            type: Boolean,
            default: null
        },
        id: {
            type: Number,
            required: true
        }
    },
    created() {
        this.init();
    },
    data() {
        return {
            visible: false,
            OrderData: {},
            changeProductList: [],
            changeProductList2: [],
            isShow: false,
            dialogTabsVisible: false,
            selectTemp: {},
            activeName: '1',
            returnConfigList: [],
            confirmFormData: {},

            totalNum1: 0,
            totalNum2: 0,
            num2: [],
            changePic: []
        }
    },
    watch: {
        value(b) {
            if (!b) return

            this.visible = b
            this.reset()
        },
        visible(b) {
            this.$emit('input', b)
        }
    },
    methods: {
        getConfirmFormData() {
            return cloneDeep({
                "OrderId": 0,
                "ReturnRemark": "",
                "NewList": [],
                "ActualList": []
            });
        },
        init(options) {
            this.confirmFormData = this.getConfirmFormData();
        },
        reset() {
            this.getInfo();
        },
        //添加资源包
        addTableCell() {
            this.changeProductList.push({
                "ChangeProId": 0,
                "ChangeProName": "请选择资源包",
                "maxNum": Infinity,
                "num": 0
            });
        },
        //進入可修改狀態
        changeBtn() {
            this.isShow = true

            for (let i = 0; i < this.changeProductList.length; i++) {
                this.changeProductList[i].maxNum = Infinity
            }
        },
        //刪除資源包
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        //打開可選资源包列表
        getConfig(item) {
            this.selectTemp = item;
            this.getReturnConfig(item);
        },
        //选择资源包
        chooseList(index, item, itemList) {
            for (var i = 0; i < this.returnConfigList.length; i++) {
                for (var j = 0; j < this.returnConfigList[i].List.length; j++) {
                    this.returnConfigList[i].List[j].active = false;
                }
            }
            item.active = true;
            let ProName = item.ProName;
            item.ProName = " ";
            item.ProName = ProName;

        },
        //確定選擇
        enSure() {
            for (var i = 0; i < this.returnConfigList.length; i++) {
                for (var j = 0; j < this.returnConfigList[i].List.length; j++) {
                    if (this.returnConfigList[i].List[j].active) {
                        //如果表格存在这个资源包，提示
                        for (let k = 0; k < this.changeProductList.length; k++) {
                            if (this.returnConfigList[i].List[j].ProId == this.changeProductList[k].ChangeProId) {
                                this.$notify({
                                    title: '提示',
                                    message: '实际换货列表已存在该资源包!',
                                    type: 'warning'
                                });
                                return;
                            }
                        }

                        this.selectTemp.ChangeProName = this.returnConfigList[i].List[j].ProName;
                        this.selectTemp.ChangeProId = this.returnConfigList[i].List[j].ProId;
                        this.selectTemp.Type = this.returnConfigList[i].List[j].Type;
                        this.dialogTabsVisible = false;
                    }
                }
            }
        },
        close() {
            this.isShow = false;
            this.visible = false;
        },
        submit() {
            this.confirmFormData.NewList = [];
            this.confirmFormData.ActualList = [];
            let changeTotalNum1 = 0;
            let changeTotalNum2 = 0; //换货简装数
            lg(this.changeProductList[0].ChangeProId)
            for (let i = 0; i < this.changeProductList.length; i++) {

                if (this.changeProductList[i].num > 0 && this.changeProductList[i].ChangeProId > 0) {
                    if (this.changeProductList[i].Type == 0) {
                        changeTotalNum1 += this.changeProductList[i].num
                    } else {
                        changeTotalNum2 += this.changeProductList[i].num
                    }
                    this.confirmFormData.NewList.push({
                        ChangeProId: this.changeProductList[i].ChangeProId,
                        ChangeNum: this.changeProductList[i].num
                    })
                }
            }
            this.confirmFormData.ActualList = cloneDeep(this.OrderData.ActualProductList)
            // for (let i = 0; i < this.num2.length; i++) {
            //     if (this.num2[i] > 0) {
            //         this.confirmFormData.ActualList.push({
            //             ActualProId: this.OrderData.ReturnProductInitList[i].ReturnProId,
            //             ActualNum: this.num2[i]
            //         })
            //     }
            // }
            /*
            提示：
                1：38码洋配多了===38码洋资源包配置超出退还数量
                2：58码洋配多了===58码洋资源包配置超出退还数量
                3：都配多了===实际换货数量不得大于退还资源包数量
            */
            lg(this.confirmFormData)
            if (this.confirmFormData.NewList.length <= 0) {
                this.$notify({
                    title: '提示',
                    message: '请配置实际换货数量!',
                    type: 'warning'
                });
            } else if (changeTotalNum1 > this.totalNum1) {
                this.$notify({
                    title: '提示',
                    message: '58码洋资源包配置超出退还数量',
                    type: 'warning'
                });
            } else if (changeTotalNum2 > this.totalNum2) {
                this.$notify({
                    title: '提示',
                    message: '38码洋资源包配置超出退还数量',
                    type: 'warning'
                });
            } else {
                this.confirmFormData.OrderId = this.id
                this.ReturnOrderConfirm(this.confirmFormData)
            }

        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/Exchange/components/exchangeConfirm/vm.js